import mapboxgl from "mapbox-gl";
import MapboxWorker from "mapbox-gl/dist/mapbox-gl-csp-worker";

let isWorkerConfigured = false;
const MAPBOX_LOCAL_WORKER_URL = `${process.env.PUBLIC_URL || ""}/mapbox-gl-csp-worker.js`;

export default function configureMapboxWorker() {
  if (isWorkerConfigured) return;
  // Use same-origin worker in production to avoid cross-origin SecurityError.
  if (process.env.NODE_ENV === "production") {
    mapboxgl.workerUrl = MAPBOX_LOCAL_WORKER_URL;
    isWorkerConfigured = true;
    return;
  }

  // Development/local fallback.
  const WorkerClass = (MapboxWorker && MapboxWorker.default) || MapboxWorker;
  if (typeof WorkerClass === "function") mapboxgl.workerClass = WorkerClass;
  isWorkerConfigured = true;
}
